import SettingsWrapper from '../SettingsWrapper.vue';
import PipelinesIndex from './PipelinesIndex.vue';
import PipelineEditor from './PipelineEditor.vue';
import FollowUpTemplatesIndex from './FollowUpTemplatesIndex.vue';
import FollowUpTemplateEditor from './FollowUpTemplateEditor.vue';
import { frontendURL } from 'dashboard/helper/URLHelper';

// Segue o padrão de agentBot.routes.js: `SettingsWrapper` sem props extras -
// cada página renderiza seu próprio header via SettingsLayout + BaseSettingsHeader.
// Passar `headerTitle` via props duplica o título no topo da tela.
export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/pipelines'),
      component: SettingsWrapper,
      meta: { permissions: ['administrator'], featureFlag: 'crm' },
      children: [
        {
          path: '',
          name: 'settings_pipelines',
          meta: { permissions: ['administrator'], featureFlag: 'crm' },
          component: PipelinesIndex,
        },
        {
          path: ':pipelineId',
          name: 'settings_pipeline_edit',
          meta: { permissions: ['administrator'], featureFlag: 'crm' },
          component: PipelineEditor,
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/settings/follow-up-templates'),
      component: SettingsWrapper,
      meta: { permissions: ['administrator'], featureFlag: 'crm' },
      children: [
        {
          path: '',
          name: 'settings_follow_up_templates',
          meta: { permissions: ['administrator'], featureFlag: 'crm' },
          component: FollowUpTemplatesIndex,
        },
        {
          path: ':id',
          name: 'settings_follow_up_template_edit',
          meta: { permissions: ['administrator'], featureFlag: 'crm' },
          component: FollowUpTemplateEditor,
        },
      ],
    },
  ],
};
